







































import Vue from 'vue'
import NonEmptyInput from '@/UI/Auction/PersonalData/Fields/NonEmptyInput.vue'
import NifInput from '@/UI/Shared/NifInput.vue'
import SurnameByNifInput from '@/UI/Shared/SurnameByNifInput.vue'
import { RepresentationData } from '@/Infrastructure/Store/Auction/RepresentationData'

export default Vue.extend({
  name: 'RepresentationForm',
  components: { SurnameByNifInput, NifInput, NonEmptyInput },
  props: {
    formDisabled: {
      type: Boolean,
      default: false
    },
    previousData: {
      type: Object as () => RepresentationData,
      required: true
    }
  },
  data () {
    return {
      name: '',
      firstSurname: '',
      secondSurname: '',
      nif: ''
    }
  },
  computed: {
    requiredNif (): string {
      if (this.name !== '') { return 'required' }
      return ''
    }
  },
  watch: {
    previousData (newValue: RepresentationData, oldValue: RepresentationData) {
      if (newValue !== oldValue) {
        this.parsePreviousData(newValue)
      }
    }
  },
  created () {
    this.parsePreviousData(this.previousData)
  },
  methods: {
    emitUpdatedData () {
      this.$emit('representation-form-updated', {
        name: this.name,
        firstSurname: this.firstSurname,
        secondSurname: this.secondSurname,
        nif: this.nif
      })
    },
    parsePreviousData (data: RepresentationData) {
      this.name = data.name
      this.firstSurname = data.firstSurname
      this.secondSurname = data.secondSurname
      this.nif = data.nif
    }
  }
})
